import { render, staticRenderFns } from "./DesktopMenuItem.vue?vue&type=template&id=1bae3736&"
import script from "./DesktopMenuItem.vue?vue&type=script&lang=js&"
export * from "./DesktopMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./DesktopMenuItem.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports